export default "__VITE_ASSET__GIuEpxFX__"